import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-important-information',
  templateUrl: './important-information.component.html',
  styleUrls: ['./important-information.component.scss'],
  standalone: false,
})
export class ImportantInformationComponent {
  @Input() title: any;
  @Input() text: any;
  @Input() hasMoreInfo: boolean = false;

  isMoreInfoVisible = false;

  toggleMoreInfo() {
    this.isMoreInfoVisible = !this.isMoreInfoVisible;
  }
}
